import { CURRENCIES } from '@weft/types';
import { countries } from 'countries-list';

export const DEFAULT_ADDRESS_COUNTRY = countries.US.name;
export const DEFAULT_SETTINGS_CURRENCY = CURRENCIES.Usd;
export const DEFAULT_DUE_DAYS = 30;